import { useState, useEffect, useRef, useCallback } from "react";

export const usePortalCatalogueParams = (options = {}) => {
  const defaultPageSize = options.defaultPageSize || 10;

  const [searchValue, setSearchValueState] = useState("");
  const [debouncedSearch, setDebouncedSearch] = useState("");
  const [activeCategoryId, setActiveCategoryId] = useState(null);
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(defaultPageSize);
  const [ordering, setOrdering] = useState(null);

  const timerRef = useRef(null);

  // Debounced search logic
  const setSearchValue = useCallback(val => {
    setSearchValueState(val);
    if (timerRef.current) {
      clearTimeout(timerRef.current);
    }
    timerRef.current = setTimeout(() => {
      // gate: min 2 characters or empty
      if (val === "" || val.length >= 2) {
        setDebouncedSearch(val);
        setPage(1); // Reset page on search changes
      }
    }, 400);
  }, []);

  const setCategoryId = useCallback(id => {
    setActiveCategoryId(id);
    setPage(1); // Reset page on filter changes
  }, []);

  const changePageSize = useCallback(size => {
    setPageSize(size);
    setPage(1); // Reset page on limit changes
  }, []);

  useEffect(() => {
    return () => {
      if (timerRef.current) {
        clearTimeout(timerRef.current);
      }
    };
  }, []);

  // Compute limit/offset for Django paginator API
  const limit = pageSize;
  const offset = (page - 1) * pageSize;

  const queryParams = {
    limit,
    offset,
  };

  if (debouncedSearch) {
    queryParams.search = debouncedSearch;
  }
  if (activeCategoryId) {
    queryParams.portal_category_ids = activeCategoryId;
    queryParams.include_subcategories = true;
  }
  if (ordering) {
    queryParams.ordering = ordering;
  }

  return {
    searchValue,
    activeCategoryId,
    page,
    pageSize,
    queryParams,
    setSearchValue,
    setCategoryId,
    setPage,
    setPageSize: changePageSize,
    setOrdering,
  };
};
